import Styles from './UnsupportedRequestContent.module.scss'
import { UnsupportedRequestContentProps } from '../Types'
import { Button } from 'blaze-ui/Button'
import { generatePath, useHistory } from 'react-router-dom'
import { BRAND_KITS_PATH, DESIGN_PATH } from 'paths'
import { ArrowUpRight } from 'blaze-ui/icons/16'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

const DesignNavigationButton = ({ design_id }: { design_id: string }) => {
  const history = useHistory()

  const handleOpenDesigner = () => {
    history.push(generatePath(DESIGN_PATH, { key: design_id }))
  }

  return (
    <div>
      <Button
        rounded
        variant="tertiary"
        size="sm"
        endIcon={() => <ArrowUpRight color="var(--dark-40)" />}
        onPress={handleOpenDesigner}
      >
        Edit in Designer
      </Button>
    </div>
  )
}

const BrandKitStylesNavigationButton = () => {
  const workspaceId = useCurrentWorkspaceId()
  const history = useHistory()

  const handleOpenBrandKitStyles = () => {
    history.push({ pathname: generatePath(BRAND_KITS_PATH, { workspaceId }), hash: 'styles_voice' })
  }

  return (
    <div>
      <Button
        rounded
        variant="tertiary"
        size="sm"
        endIcon={() => <ArrowUpRight color="var(--dark-40)" />}
        onPress={handleOpenBrandKitStyles}
      >
        Update Brand Styles
      </Button>
    </div>
  )
}

const BrandKitContentPreferencesNavigationButton = () => {
  const workspaceId = useCurrentWorkspaceId()
  const history = useHistory()

  const handleOpenBrandKitContentPreferences = () => {
    history.push({ pathname: generatePath(BRAND_KITS_PATH, { workspaceId }), hash: 'content_preferences' })
  }

  return (
    <div>
      <Button
        rounded
        variant="tertiary"
        size="sm"
        endIcon={() => <ArrowUpRight color="var(--dark-40)" />}
        onPress={handleOpenBrandKitContentPreferences}
      >
        Update Content Preferences
      </Button>
    </div>
  )
}

export const UnsupportedRequestContent = observer(({ content }: UnsupportedRequestContentProps) => {
  const { designStore } = useRootStore()
  const { navigation, design_id } = content
  const isDesignNavigation = navigation?.length === 1 && navigation[0] === 'design'
  const isInDesign = designStore && design_id && designStore.fileId === design_id

  if (navigation == null || navigation?.length === 0 || (isDesignNavigation && !design_id)) {
    return null
  }

  return (
    <div className={Styles.unsupportedRequestContent}>
      {navigation.includes('design') && design_id && !isInDesign && <DesignNavigationButton design_id={design_id} />}
      {navigation.includes('brand_kit_styles') && <BrandKitStylesNavigationButton />}
      {navigation.includes('brand_kit_content_preferences') && <BrandKitContentPreferencesNavigationButton />}
    </div>
  )
})
